import React from "react";
import * as Redux from 'react-redux';
import { Embed } from 'semantic-ui-react';

import TopMenu from './TopMenu';

export class Tutorials extends React.Component {
	componentDidMount() {
		document.title = "Tutorials";
	}

	render() {
		return (
			<div>
				<TopMenu />
				<div className="ui basic segment page-content">
					<h2>General Tutorial</h2>
					<Embed id='CSyO0aBwEb4' source='youtube' autoplay={true} active={true} />
               <h2>Add / Update / Bulk Update Rental Listings</h2>
					<Embed id='pan0GXgyn7s' source='youtube' autoplay={true} active={true} />
				</div>
			</div>
		);
	}
}

export default Redux.connect(
	(state) => {
		return state;
	}
)(Tutorials);



// WEBPACK FOOTER //
// ./src/components/Tutorials.js